import { Reveal } from "./Reveal";
import { SectionHeading } from "./Section";

const STEPS = [
  {
    n: "1",
    title: "Masukkan Data Usaha",
    text: "Isi data bahan, biaya, harga, atau informasi usaha lain yang diperlukan oleh fitur yang ingin kamu gunakan.",
  },
  {
    n: "2",
    title: "Lihat Hasil Perhitungan",
    text: "Gunakan hasil HPP, harga jual, margin, atau BEP sebagai bahan pertimbangan sebelum mengambil keputusan.",
  },
  {
    n: "3",
    title: "Catat dan Tinjau Penjualan",
    text: "Untuk usaha yang sudah berjalan, gunakan fitur pencatatan penjualan dan laporan yang tersedia untuk membantu memahami perkembangan usaha.",
  },
];

export function HowItWorks() {
  return (
    <section id="cara-kerja" className="scroll-mt-20 bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading title="Cara Kerjanya Sederhana" />
        </Reveal>
        <ol className="mt-12 grid gap-5 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <li className="relative h-full rounded-2xl border border-slate-200 bg-slate-50/60 p-6">
                <span className="text-4xl font-extrabold tracking-tight text-teal-600/25">
                  {s.n}
                </span>
                <h3 className="mt-3 text-lg font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
